import { createContext, useContext, ParentComponent } from "solid-js";
import { DenominationGridStateV2 } from "~/hooks/denominations_grid_v2/useDenominationsGrid";

const DenominationsGridV2Context = createContext<DenominationGridStateV2>();
export const DenominationsGridV2Provider: ParentComponent<{
  value: DenominationGridStateV2;
}> = (props) => {
  return (
    <DenominationsGridV2Context.Provider value={props.value}>
      {props.children}
    </DenominationsGridV2Context.Provider>
  );
};

export const useDenominationsGridV2Context = () => {
  const context = useContext(DenominationsGridV2Context);
  if (!context) {
    throw new Error(
      "useDenominationsGridV2Context must be used within a DenominationsGridV2Provider"
    );
  }
  return context;
};
